// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"edb3510b","375":"874b085c","498":"b1846cea","500":"4f9a8436","565":"e6751ce2","579":"f130e584","629":"ae3f9505","706":"b8c6356d","750":"25de5ea5"}[chunkId] + ".chunk.js";
};